export default {
  de: {
    demoRobots: 'Demo Roboter'
  },
  en: {
    demoRobots: 'Demo robots'
  },
  es: {
    demoRobots: 'Robots de demostración'
  }
}
